import { render, staticRenderFns } from "./subSkiiScore.vue?vue&type=template&id=2540d6fe&scoped=true"
import script from "./subSkiiScore.vue?vue&type=script&lang=js"
export * from "./subSkiiScore.vue?vue&type=script&lang=js"
import style0 from "./subSkiiScore.vue?vue&type=style&index=0&id=2540d6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2540d6fe",
  null
  
)

export default component.exports